// extracted by mini-css-extract-plugin
export var circle = "_3i-2";
export var icon = "_3i-a";
export var iconHighlight = "_3i-0";
export var lg = "_3i-8";
export var md = "_3i-7";
export var outline = "_3i-4";
export var sm = "_3i-6";
export var square = "_3i-1";
export var xl = "_3i-9";
export var xs = "_3i-5";
export var xxs = "_3i-3";